export default __webpack_public_path__ + "static/media/ucPrototype.293c7f8a.png";